import PilotAssistantAPI from 'dashboard/api/pilot/assistant';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'PilotAssistant',
  API: PilotAssistantAPI,
  getters: {
    getRecords: state => state.records, // 移除自动排序，保持后端返回的顺序
  },
  actions: types => ({
    async update({ commit, state }, { id, data }) {
      commit(types.SET_UI_FLAG, { updatingItem: true });
      try {
        // 调用 API 更新
        const response = await PilotAssistantAPI.update(id, data);

        // 更新本地 records 中的对应项
        const updatedRecords = state.records.map(record => {
          if (record.id === id) {
            return response.data;
          }
          return record;
        });
        commit(types.SET, updatedRecords);

        commit(types.SET_UI_FLAG, { updatingItem: false });

        return response.data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { updatingItem: false });
        throw error;
      }
    },
    async show({ commit }, params) {
      commit(types.SET_UI_FLAG, { fetchingList: true });
      try {
        const { data } = await PilotAssistantAPI.show(params.id, params);
        commit(types.SET_UI_FLAG, { fetchingList: false });
        return data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { fetchingList: false });
        throw error;
      }
    },
    async filter(
      { commit },
      { page = 1, sortAttr, queryPayload, search, resetState = true } = {}
    ) {
      commit(types.SET_UI_FLAG, { fetchingList: true });
      try {
        const { data } = await PilotAssistantAPI.filter(
          page,
          sortAttr,
          queryPayload,
          search
        );
        if (resetState) {
          commit(types.SET, data.payload);
          commit(types.SET_META, data.meta);
        }
        commit(types.SET_UI_FLAG, { fetchingList: false });
        return data.payload;
      } catch (error) {
        commit(types.SET_UI_FLAG, { fetchingList: false });
        throw error;
      }
    },
    removeBulkAssistants: ({ commit, state }, ids) => {
      const updatedRecords = state.records.filter(
        record => !ids.includes(record.id)
      );
      commit(types.SET, updatedRecords);
    },
  }),
});
